import { render, staticRenderFns } from "./CumAddCart.vue?vue&type=template&id=5846ddab&"
import script from "./CumAddCart.vue?vue&type=script&lang=js&"
export * from "./CumAddCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports